import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Link,
  makeStyles,
  Typography,
  AppBar,
  Toolbar,
  FormControl,
  TextareaAutosize,
  Select,
  InputLabel,
  NativeSelect,
  MenuItem,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import ErrorIcon from "@material-ui/icons/Error";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import EditIcon from "@material-ui/icons/Edit";
import DateRangeIcon from "@material-ui/icons/DateRange";
import ScheduleIcon from "@material-ui/icons/Schedule";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import HistoryIcon from "@material-ui/icons/History";
import { FormHelperText } from "@material-ui/core";

import DateComponent from "../../../../../Components/FormGenerator/datepicker_component";

import CustomInput from "../../../../../Components/CustomInput";
import DataClient from "../../../../../Service/general_data_service";
import CustomSelectMulti from "../../../../../Components/CustomSelectMulti";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import { useDispatch, useSelector } from "react-redux";
import DataService from "../../../../../Service";
import {
  DateFormat,
  DateFormatter,
} from "../../../../../Common/Utils/common_utils";
import moment from "moment";
import { KeyboardTimePicker, TimePicker } from "@material-ui/pickers";
import AlertDialog from "../../../../../Components/CustomDialog";
import Caf from "./Caf/editCaf";

const exceededWarning = (minutesRemaining) => {
  if (minutesRemaining < 60) {
    return minutesRemaining + " minutes";
  } else {
    let hoursString = Math.floor(minutesRemaining / 60) + " hours";
    if (minutesRemaining % 60 > 0) {
      hoursString = `${hoursString} ${minutesRemaining % 60} minutes`;
    }
    return hoursString;
  }
};

const useStyles = makeStyles((theme) => ({
  overviewContainer: {
    position: "sticky",
    top: 64,
    paddingTop: 40,
    background: "#fff",
    zIndex: 1,
  },
  appBar: {
    backgroundColor: "#fff",
    color: "#232323",
    boxShadow: "0px 3px 6px #232323",
    marginBottom: "2rem",
  },
  custom_timepicker: {
    "& .MuiInputBase-root": {
      border: "1px solid rgba(0, 0, 0, 0.23)",
      borderRadius: 5,
    },
    "& .MuiInputBase-input": {
      padding: "9px 12px !important",
      "&:focus": {
        borderColor: "#077F83",
      },
    },
    "& .MuiInput-underline.Mui-error:after, & .MuiInput-underline:before": {
      content: "' '",
      border: "0px !important",
      transition: "none",
    },
    "& .MuiIconButton-root": {
      padding: "0px 5px 0px 0px",
    },
  },
  textAreaEmpty: {
    color: "rgba(0, 0, 0, 0.87)",
    width: "97%",
    border: "1px solid rgb(196 196 196)",
    padding: "10px",
    borderRadius: "4px",
    font: "inherit",
    display: "block",
    outline: "none",

    "&:focus": {
      border: "2px solid  #077F83",
    },
  },
  nativeSelect: {
    fontSize: "14px",
    paddingLeft: "0.25rem",
    border: "1px solid grey",
    height: "100%",
    width: "100%",
    borderRadius: "5%",
    "& select": {
      padding: "10px",
      "&:focus": {
        backgroundColor: "transparent",
      },
    },
    "&::before": {
      borderBottom: "0px !important",
    },
    "&::after": {
      outline: "2px solid  #077F83",
      border: "none !important",
      top: "0",
      borderRadius: "3px",
    },
    "&:hover": {
      border: "0.5px solid black",
    },
  },
  nativeOption: {
    padding: "5px",
  },
}));

function Sessions(props) {
  const classes = useStyles();
  console.log(props, "props for sessions");
  const { sessionStatus, setSessionStatus } = props;
  const [open, setOpen] = useState(false);
  const [maxWidth, setMaxWidth] = useState("md");
  const [stakeholderListsArr, setsStakeholderListsArr] = useState([]);
  const [stakeholder_Attribute, setStakeholder_Attribute] = useState([]);
  const [action, setAction] = useState("");
  const [sessionDetail, setSessionDetail] = useState({});
  const [warningArr, setWarningArr] = useState([]);
  const dispatch = useDispatch();
  const [permissionForSession, setPermissionForSession] = useState([]);
  const [submitClickFlag, setSubmitClickFlag] = useState(false);
  const [dialogState, setDialogState] = useState(undefined);
  const [textArea, setTextArea] = useState({
    agenda: "",
    note_to_acuity_admin: "",
    session_notes: "",
  });
  ///
  const [hourArray, setHourArray] = useState();
  const [minuteArray, setMinuteArray] = useState();
  const [sessionDetailID, setSessionDetailID] = useState();
  const globaluserData = useSelector((state) => state.commonReducer);
  let role = globaluserData.role;
  // let role = sessionStorage.getItem("role");
  //Access Permission
  const accessLevel = useSelector((state) => state.commonReducer).accessLevel;
  const accessArray = useSelector((state) => state.commonReducer)
    ?.accessPermission?.assignmentDetail.actionPlaning;
  const showAcuityNotes = useSelector((state) => state.commonReducer)
    ?.accessPermission?.assignmentDetail.sessions?.showAcuityNotes;
  useEffect(() => {
    setPermissionForSession(accessArray);
  }, [accessArray]);
  const [sessionInputErrors, setSessionInputErrors] = useState({
    session_date: false,
    location: false,
    stakeHoldersInvolved: false,
    start_time_hours: false,
    start_time_minutes: false,
    end_time_hours: false,
    end_time_minutes: false,
  });
  const [userData, setUserData] = useState({
    session_date: "",
    // start_time: "",
    // end_time: "",
    location: "",
  });
  const [clockData, setClockData] = useState({
    start_time_hours: "",
    start_time_minutes: "",
    end_time_hours: "",
    end_time_minutes: "",
  });

  const fetchProgramInfo = () => {
    DataService.getData(
      { assignment_id: props.assignmentId },
      `assignment_program_info`
    )
      .then((res) => {
        if (res.success) {
          const isMidPoint = res.programme_info.programme_info_modules.find(
            (module) => module.module_name === "Mid-Point Review/Interim Review"
          );
          if (isMidPoint) {
            permissionForSession.push("Edit");
            setPermissionForSession([...permissionForSession]);
          }
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (
      props.assignmentId &&
      (accessLevel === "Level 3" || accessLevel === "Level 4")
    ) {
      props.assignmentId && fetchProgramInfo();
    }
  }, [props.assignmentId, accessLevel]);

  useEffect(() => {
    getData();
    getStakeHolder();
  }, [props.title]);
  const getData = (params) => {
    const session_detail_id = params;
    // var pdata =
    //   "&pgm_flow_id=" +
    //   props.currentObj.pgm_flow_id +
    //   "&assignment_id=" +
    //   props.assignmentId +
    //   "&session_detail_id=" +
    //   sessionDetailID;
    // props.id != "" && (pdata += "&sequence_id=" + props.id);
    var pdata = {
      // session_detail_id: sessionDetailID,
      pgm_flow_id: props.currentObj.pgm_flow_id,
      assignment_id: props.assignmentId,
    };
    props.id !== "" && (pdata["sequence_id"] = props.id);
    DataService.getDirectData("/session_details/fetch_session_detail?", pdata)
      .then((res) => {
        setSessionDetail(res.session_detail);

        let sessionDetailID =
          res.session_detail.length > 0 ? res.session_detail[0].id : "";
        setSessionDetailID(sessionDetailID);
      })
      .catch((res) => {});
  };

  const getStakeHolder = () => {
    DataClient.getData(
      "session_details/fetch_stakeholders_involved_in?assignment_id=" +
        props.assignmentId
    )
      .then((res) => {
        res.stakeholder_user.map((option) => (option["value"] = option.name));
        stakeholderListsArr.length = 0;
        setsStakeholderListsArr(
          stakeholderListsArr.concat(res.stakeholder_user)
        );
      })
      .catch((res) => {});
  };
  const handleChangeTextArea = (event) => {
    const { name, value } = event.target;
    setTextArea((prev) => ({ ...prev, [name]: value }));
  };

  const handleClickOpen = () => {
    setOpen(true);
    createHourOption();
    createMinuteOption();
  };

  const handleClose = () => {
    setOpen(false);
    setUserData({
      ...userData,
      session_date: "",
      location: "",
    });
    setTextArea({
      agenda: "",
      session_notes: "",
      note_to_acuity_admin: "",
    });
    setClockData({
      start_time_hours: "",
      start_time_minutes: "",
      end_time_hours: "",
      end_time_minutes: "",
    });
    setSubmitClickFlag(false);
    stakeholder_Attribute.length = 0;
    setSessionInputErrors({
      session_date: false,
      location: false,
      stakeHoldersInvolved: false,
      start_time_hours: false,
      start_time_minutes: false,
      end_time_hours: false,
      end_time_minutes: false,
    });
  };

  const setInputState = (inputStateValue, inputId) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
    if (["session_date", "location"].includes(inputId)) {
      if (inputStateValue) {
        setSessionInputErrors((prev) => {
          return { ...prev, [inputId]: false };
        });
      }
    }
  };

  const selectChange = (value, key) => {
    setClockData((prev) => {
      return { ...prev, [key]: value };
    });
    if (value !== "") {
      setSessionInputErrors((prev) => {
        return { ...prev, [key]: false };
      });
    }
  };

  const onChangeMultiItem = (obj, inputId, routeFrom) => {
    if (inputId == "stakeholder_Attribute") {
      if (obj.length > 0) {
        setSessionInputErrors((prev) => {
          return { ...prev, stakeHoldersInvolved: false };
        });
      }
      stakeholder_Attribute.length = 0;
      setStakeholder_Attribute(stakeholder_Attribute.concat(obj));
    }
  };
  function getTimeDifference(startTime, endTime) {
    const difference = endTime - startTime;
    const differenceInMinutes = difference / 1000 / 60;
    let hours = Math.floor(differenceInMinutes / 60);
    if (hours < 0) {
      hours = 24 + hours;
    }
    let minutes = Math.floor(differenceInMinutes % 60);
    if (minutes < 0) {
      minutes = 60 + minutes;
    }
    const hoursAndMinutes = hours + ":" + (minutes < 10 ? "0" : "") + minutes;
    return hoursAndMinutes;
  }

  console.log("props.remaining", props.remainingTime);

  const saveSession = (e) => {
    e.preventDefault();
    console.log(
      `${clockData.start_time_hours} : ${clockData.start_time_minutes}`
    );
    let blockRequest = false;

    if (userData.session_date === "" || userData.session_date === null) {
      setSessionInputErrors((prev) => {
        return { ...prev, session_date: true };
      });
      blockRequest = true;
    }
    if (userData.location === "") {
      setSessionInputErrors((prev) => {
        return { ...prev, location: true };
      });
      blockRequest = true;
    }
    if (stakeholder_Attribute.length === 0) {
      setSessionInputErrors((prev) => {
        return { ...prev, stakeHoldersInvolved: true };
      });
      blockRequest = true;
    }

    const timeError = {
      start_time_hours: false,
      start_time_minutes: false,
      end_time_hours: false,
      end_time_minutes: false,
    };
    if (clockData.start_time_hours === "") {
      timeError.start_time_hours = true;
    }
    if (clockData.start_time_minutes === "") {
      timeError.start_time_minutes = true;
    }
    if (clockData.end_time_hours === "") {
      timeError.end_time_hours = true;
    }
    if (clockData.end_time_minutes === "") {
      timeError.end_time_minutes = true;
    }
    if (
      timeError.start_time_hours ||
      timeError.start_time_minutes ||
      timeError.end_time_hours ||
      timeError.end_time_minutes
    ) {
      setSessionInputErrors((prev) => {
        return { ...prev, ...timeError };
      });
      blockRequest = true;
    }

    if (blockRequest) {
      setSubmitClickFlag(true);
      return;
    } else {
      var stakeholderLocalArr =
        stakeholder_Attribute.length > 0 &&
        stakeholder_Attribute.map((option) => option.id);
      const start = new Date(
        0,
        0,
        0,
        clockData.start_time_hours,
        clockData.start_time_minutes
      );
      const end = new Date(
        0,
        0,
        0,
        clockData.end_time_hours,
        clockData.end_time_minutes
      );
      const difference = getTimeDifference(start, end);
      function convertHourstoMinute(str) {
        let [hours, minutes] = str.split(":");
        return +hours * 60 + +minutes;
      }
      const minutesDiff = convertHourstoMinute(difference);
      const minutesRemaining = props.remainingTime * 60;
      console.log("op", minutesDiff, minutesRemaining);

      if (minutesDiff > minutesRemaining) {
        if (props.currentObj.make_new_pgm_flow_setups) {
          let timerId = setInterval(() => {
            dispatch(
              showSnackbar("error", [
                "You have exceeded the available session hours!",
              ])
            );
          }, 1000);
          setTimeout(() => {
            clearInterval(timerId);
          }, 6000);
          setTimeout(() => {
            if (action == "save") {
              const pdata = {
                sequence_id: props.id == "" ? null : props.id,
                assignment_id: props.assignmentId,
                pgm_flow_id: props.currentObj.pgm_flow_id,
                ...userData,
                stakeholder_user_id: stakeholderLocalArr,
                session_date: DateFormat(userData.session_date),
                start_time: `${clockData.start_time_hours} : ${clockData.start_time_minutes}`,
                end_time: `${clockData.end_time_hours} : ${clockData.end_time_minutes}`,
                ...textArea,
                agenda: textArea.agenda,
                note_to_acuity_admin: textArea.note_to_acuity_admin,
                session_notes: textArea.session_notes,
              };
              DataClient.create(pdata, "session_details")
                .then((res) => {
                  setSessionDetailID(res.session_detail_id);
                  getData();
                  dispatch(
                    showSnackbar("Success", ["Information saved successfully"])
                  );
                  handleClose();
                  getData();
                  getStakeHolder();
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          }, 7000);

          setTimeout(() => {
            if (action == "edit") {
              const pdata = {
                assignment_id: props.assignmentId,
                session_detail_id: sessionDetailID,
                ...userData,
                pgm_flow_id: props.currentObj.pgm_flow_id,
                stakeholder_user_id: stakeholderLocalArr,
                session_date: DateFormat(userData.session_date),
                start_time: `${clockData.start_time_hours} : ${clockData.start_time_minutes}`,
                end_time: `${clockData.end_time_hours} : ${clockData.end_time_minutes}`,
                ...textArea,
                agenda: textArea.agenda,
                note_to_acuity_admin: textArea.note_to_acuity_admin,
                session_notes: textArea.session_notes,
              };
              DataClient.update(pdata, "session_details/update_session_detail")
                .then((res) => {
                  dispatch(
                    showSnackbar("Success", [
                      "Information updated successfully",
                    ])
                  );
                  handleClose();
                  getData();
                })
                .catch((res) => {});
            }
          }, 7000);
        } else {
          dispatch(
            showSnackbar(
              "error",
              [
                `Please try again, the session duration should be within ${exceededWarning(
                  minutesRemaining
                )}`,
              ],
              3000
            )
          );
        }
      } else {
        if (action == "save") {
          const pdata = {
            sequence_id: props.id == "" ? null : props.id,
            assignment_id: props.assignmentId,
            pgm_flow_id: props.currentObj.pgm_flow_id,
            ...userData,
            stakeholder_user_id: stakeholderLocalArr,
            session_date: DateFormat(userData.session_date),
            start_time: `${clockData.start_time_hours} : ${clockData.start_time_minutes}`,
            end_time: `${clockData.end_time_hours} : ${clockData.end_time_minutes}`,
            ...textArea,
            agenda: textArea.agenda,
            note_to_acuity_admin: textArea.note_to_acuity_admin,
            session_notes: textArea.session_notes,
          };
          DataClient.create(pdata, "session_details")
            .then((res) => {
              setSessionDetailID(res.session_detail_id);
              getData();
              dispatch(
                showSnackbar("Success", ["Information saved successfully"])
              );
              handleClose();
              getData();
              getStakeHolder();
            })
            .catch((error) => {
              console.log(error);
            });
        }
        if (action == "edit") {
          const pdata = {
            assignment_id: props.assignmentId,
            session_detail_id: sessionDetailID,
            ...userData,
            pgm_flow_id: props.currentObj.pgm_flow_id,
            stakeholder_user_id: stakeholderLocalArr,
            session_date: DateFormat(userData.session_date),
            start_time: `${clockData.start_time_hours} : ${clockData.start_time_minutes}`,
            end_time: `${clockData.end_time_hours} : ${clockData.end_time_minutes}`,
            ...textArea,
            agenda: textArea.agenda,
            note_to_acuity_admin: textArea.note_to_acuity_admin,
            session_notes: textArea.session_notes,
          };
          DataClient.update(pdata, "session_details/update_session_detail")
            .then((res) => {
              dispatch(
                showSnackbar("Success", ["Information updated successfully"])
              );
              handleClose();
              getData();
            })
            .catch((res) => {});
        }
      }
    }
  };

  const updateSession = (url) => {
    var pdata = {
      session_detail_id: sessionDetailID,
      pgm_flow_id: props.currentObj.pgm_flow_id,
      assignment_id: props.assignmentId,
    };
    props.id != "" && (pdata["sequence_id"] = props.id);
    DataClient.create(pdata, url)
      .then((res) => {
        setWarningArr(res.warning);
        // setWarningArr(prev=>{return [...prev,...res.warning]});
        dispatch(
          showSnackbar("Success", ["Session status updated successfully"])
        );

        getData();
        props.getAssignmentModule();
      })
      .catch((res) => {});
  };
  const [showWarn, setShowWarn] = useState(false);
  useEffect(() => {
    console.log(warningArr, "warning arr show");
    if (
      warningArr?.length > 0 &&
      (props.title === firstElement || props.title === lastElement)
    ) {
      setShowWarn(true);
    }
  }, [warningArr]);
  console.log(showWarn, "show warn");
  const beforeEditSession = () => {
    setUserData({
      ...userData,
      session_date: sessionDetail[0].session_date,
      // start_time_hours: userData.start_time_hours,
      // start_time_minutes: userData.start_time_minutes,
      // end_time_hours: userData.end_time_hours,
      // end_time_minutes: userData.end_time_minutes,
      // start_time: moment(
      //   `${moment().format("YYYY-MM-DD")} ${sessionDetail.start_time}`
      // ),
      // end_time: moment(
      //   `${moment().format("YYYY-MM-DD")} ${sessionDetail.end_time}`
      // ),
      location: sessionDetail[0].location,
    });
    setClockData({
      ...clockData,
      start_time_hours:
        sessionDetail.length > 0 && sessionDetail[0].start_time.split(":")[0],
      start_time_minutes:
        sessionDetail.length > 0 && sessionDetail[0].start_time.split(":")[1],
      end_time_hours:
        sessionDetail.length > 0 && sessionDetail[0].end_time.split(":")[0],
      end_time_minutes:
        sessionDetail.length > 0 && sessionDetail[0].end_time.split(":")[1],
    });
    setTextArea({
      ...textArea,
      agenda: sessionDetail[0].agenda,
      note_to_acuity_admin: sessionDetail[0].note_to_acuity_admin,
      session_notes: sessionDetail[0].session_notes,
    });
    sessionDetail?.length > 0 &&
      sessionDetail[0]?.stakeholders?.length > 0 &&
      sessionDetail !== undefined &&
      sessionDetail[0].stakeholders.map((option) => {
        option["value"] = option.name;
        option["id"] = option.user_id;
        option["name"] = option.value;
        option["label"] = option.name;
      });
    stakeholder_Attribute.length = 0;
    setStakeholder_Attribute(
      stakeholder_Attribute.concat(sessionDetail[0].stakeholders)
    );
    setAction("edit");
    handleClickOpen();
  };

  const createHourOption = () => {
    let newArray = [];
    for (let i = 0; i <= 24; i++) {
      i.toString().length > 1 ? newArray.push(i) : newArray.push("0" + i);
    }
    setHourArray(newArray);
  };
  const createMinuteOption = () => {
    let newArray = [];
    for (let i = 0; i <= 60; i++) {
      if (i % 5 === 0) {
        i.toString().length > 1 ? newArray.push(i) : newArray.push("0" + i);
      }
    }
    setMinuteArray(newArray);
  };

  const arr = props.sessionModuleArray;
  const firstElement =
    typeof arr[0] !== "string" && arr[0].length > 0 ? arr[0][0] : arr[0];
  const lastElement =
    typeof arr[arr.length - 1] !== "string" && arr[arr.length - 1].length > 0
      ? arr[arr.length - 1][arr[arr.length - 1].length - 1]
      : arr[arr.length - 1];
  console.log(firstElement, lastElement, "first");
  return (
    <>
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid
          item
          xs={11}
          style={{ textAlign: "center" }}
          direction="row"
          justify="center"
          alignItems="center"
          className={classes.overviewContainer}
        >
          <AppBar position="static" className={classes.appBar} elevation={0}>
            <Toolbar>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                xs={12}
              >
                <Grid item xs={6}>
                  <Typography variant="h1" style={{ color: "#4A4A4A" }}>
                    <Box textAlign="left" fontWeight="fontWeightBold">
                      {props?.currentObj?.module_name}
                    </Box>
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  {console.log(
                    "Object.keys(sessionDetail :>> ",
                    Object.keys(sessionDetail)
                  )}
                  {!Object.keys(sessionDetail)?.length ? (
                    <Box textAlign="right">
                      <Button
                        variant="contained"
                        color="secondary"
                        style={{ textTransform: "inherit" }}
                        onClick={() => {
                          setAction("save");
                          handleClickOpen();
                        }}
                      >
                        <HistoryIcon /> &nbsp; Schedule session
                      </Button>
                    </Box>
                  ) : sessionDetail[0]?.status == "cancelled" ? (
                    <Box textAlign="right">
                      <Button
                        disableElevation
                        variant="contained"
                        style={{
                          backgroundColor: "#C71C1C",
                          color: "#fff",
                          textTransform: "capitalize",
                        }}
                      >
                        <CheckCircleIcon />
                        &nbsp;Cancelled
                      </Button>
                    </Box>
                  ) : sessionDetail[0]?.status != "completed" ? (
                    <Box textAlign="right">
                      <>
                        {permissionForSession?.includes("Cancel") ? (
                          <Button
                            disableElevation
                            variant="contained"
                            style={{
                              backgroundColor: "#C71C1C",
                              color: "#fff",
                              textTransform: "none",
                            }}
                            onClick={() => {
                              updateSession("session_details/cancel_session");
                            }}
                          >
                            Cancel session
                          </Button>
                        ) : null}
                        {permissionForSession?.includes("Complete") ? (
                          <Button
                            disableElevation
                            variant="contained"
                            style={{
                              backgroundColor: "transparent",
                              borderWidth: 1,
                              borderStyle: "solid",
                              borderColor: "#03B11E",
                              color: "#03B11E",
                              textTransform: "none",
                              marginLeft: 10,
                            }}
                            onClick={() =>
                              setDialogState({
                                isOpen: true,
                              })
                            }
                          >
                            Mark session as complete
                          </Button>
                        ) : (
                          ""
                        )}
                      </>
                    </Box>
                  ) : (
                    <Box textAlign="right">
                      <Button
                        disableElevation
                        variant="contained"
                        style={{
                          backgroundColor: "#21BA45",
                          color: "#fff",
                          textTransform: "none",
                        }}
                      >
                        <CheckCircleIcon />
                        &nbsp;Session completed
                      </Button>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
        </Grid>
        {showWarn ? (
          <Box p={3} borderRadius={10} bgcolor="#FFCC53">
            <Grid container direction="row">
              <Grid item xs="1">
                <ErrorIcon style={{ color: "#981B1E" }} />
              </Grid>
              <Grid item xs="11">
                <Typography style={{ color: "#981B1E" }}>
                  <Box>
                    CAF needs to be updated after session completion.
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Link
                      onClick={() => {
                        props.setPageUrl("CAF");
                        props.setSelectedIndex(1);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Click here to update
                    </Link>
                  </Box>
                </Typography>
              </Grid>
              <Grid container item xs={8}>
                {warningArr?.map((option) => {
                  return (
                    <Grid item xs={10}>
                      <Typography
                        variant="h2"
                        style={{ color: "#981B1E", marginTop: "5px" }}
                      >
                        <Box>
                          <FiberManualRecordIcon style={{ fontSize: 10 }} />
                          &nbsp;
                          {option}
                        </Box>
                      </Typography>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Box>
        ) : null}
        <Grid item xs={11}>
          {Object.keys(sessionDetail).length > 0 && (
            <>
              <Box>
                <Grid container direction="row" alignItems="center">
                  <Grid item xs="12">
                    <Grid container direction="row" alignItems="center">
                      <Grid item xs="9">
                        <Typography variant="h2">
                          <Box fontWeight="fontWeightBold">
                            <DateRangeIcon
                              style={{
                                fontSize: 20,
                                color: "#077F83",
                                verticalAlign: "middle",
                              }}
                            />{" "}
                            &nbsp;&nbsp;&nbsp;
                            <Box
                              component="span"
                              style={{ verticalAlign: "middle" }}
                            >
                              {DateFormatter(sessionDetail[0].session_date)}
                            </Box>
                          </Box>
                        </Typography>
                      </Grid>
                      {
                        <Grid item xs="3">
                          <Box textAlign="right" pr={3}>
                            {/* {permissionForSession?.includes("Edit") && ( */}
                            {/* {sessionDetail[0]?.status != "completed" && ( */}
                            <Button
                              disableElevation
                              variant="contained"
                              style={{ textTransform: "capitalize" }}
                              color="primary"
                              onClick={() => beforeEditSession()}
                            >
                              <EditIcon
                                style={{ fontSize: 16, color: "#fff" }}
                              />
                              &nbsp;Edit
                            </Button>
                            {/* )} */}
                          </Box>
                        </Grid>
                      }
                    </Grid>
                  </Grid>
                  <Grid item xs="12">
                    <Typography variant="h2">
                      <Box fontWeight="fontWeightBold" my={3}>
                        <ScheduleIcon
                          style={{
                            fontSize: 20,
                            color: "#077F83",
                            verticalAlign: "middle",
                          }}
                        />
                        &nbsp;&nbsp;&nbsp;
                        <Box
                          component="span"
                          style={{ verticalAlign: "middle" }}
                        >
                          {moment(
                            sessionDetail[0].start_time,
                            "HH:mm:ss"
                          ).format("LT") +
                            " - " +
                            moment(
                              sessionDetail[0].end_time,
                              "HH:mm:ss"
                            ).format("LT")}
                        </Box>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs="12">
                    <Typography variant="h2">
                      <Box fontWeight="fontWeightBold">
                        <LocationOnIcon
                          style={{
                            fontSize: 20,
                            color: "#077F83",
                            verticalAlign: "middle",
                          }}
                        />
                        &nbsp;&nbsp;&nbsp;
                        <Box
                          component="span"
                          style={{ verticalAlign: "middle" }}
                        >
                          {sessionDetail[0].location}
                        </Box>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
              <Box mt={6} mb={3}>
                <Grid container direction="row" alignItems="center">
                  <Grid item xs="12">
                    <Typography variant="h2">
                      <Box mb={2} fontWeight="fontWeightBold">
                        Stakeholders involved
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs="10">
                    <Grid container direction="row" alignItems="center">
                      {console.log("detail", sessionDetail[0]?.stakeholders)}
                      {sessionDetail[0]?.stakeholders?.map((option) => {
                        return (
                          <Grid item xs="3" key={option.user_id}>
                            <Grid
                              container
                              direction="row"
                              alignItems="center"
                              justify="space-between"
                              spacing={1}
                            >
                              <Grid item xs="3" md={2}>
                                <Box>
                                  <Avatar
                                    alt="Remy Sharp"
                                    src={option.image}
                                    className={classes.small}
                                  />
                                </Box>
                              </Grid>
                              <Grid item xs="9" md={10}>
                                <Box pl={1}>
                                  <Typography variant="h2">
                                    <Box fontWeight="fontWeightBold">
                                      {option.name}
                                    </Box>
                                  </Typography>
                                  <Typography
                                    variant="h2"
                                    style={{ color: "#757575" }}
                                  >
                                    <Box>{option.role}</Box>
                                  </Typography>
                                </Box>
                              </Grid>
                            </Grid>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Grid>
                  <Grid item xs="12">
                    <Typography variant="h2">
                      <Box mt={4} mb={1} fontWeight="fontWeightBold">
                        Agenda
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs="12">
                    <Typography variant="h2">
                      {sessionDetail[0].agenda}
                    </Typography>
                  </Grid>
                  <Grid item xs="12">
                    <Typography variant="h2">
                      <Box mt={4} mb={1} fontWeight="fontWeightBold">
                        Session notes
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs="12">
                    <Typography variant="h2">
                      {sessionDetail[0].session_notes}
                    </Typography>
                  </Grid>

                  {showAcuityNotes && (
                    <>
                      <Grid item xs="12">
                        <Typography variant="h2">
                          <Box mt={4} mb={1} fontWeight="fontWeightBold">
                            Acuity admin notes
                          </Box>
                        </Typography>
                      </Grid>
                      <Grid item xs="12">
                        <Typography variant="h2">
                          {sessionDetail[0].note_to_acuity_admin}
                        </Typography>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Box>
            </>
          )}
        </Grid>
      </Grid>

      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth="100%"
        maxWidth={maxWidth}
        style={{ padding: 24 }}
      >
        <form onSubmit={saveSession}>
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            <Typography variant="subtitle1">
              {props.moduleName === "Coaching session/s"
                ? "Coaching Scheduling"
                : "Scheduling"}{" "}
              {props?.title?.toLowerCase()}
            </Typography>
          </DialogTitle>
          <DialogContent dividers>
            <Box p={3}>
              <Grid container direction="row">
                <Grid
                  item
                  xs={3}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Typography variant="h2">
                    <Box>Session date</Box>
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <DateComponent
                    key={"1235"}
                    componentObject={{
                      componentType: "datePicker",
                      required: true,
                      autoFocus: true,
                      // disabled: sessionDetail?.status === "completed" ? true : false,
                      label: "",
                      name: "session_date",
                      placeholder: "Session date",
                      error: sessionInputErrors.session_date,
                      helperText:
                        submitClickFlag && sessionInputErrors.session_date
                          ? "Please select a valid date"
                          : "",
                      indexKey: "0-212",
                      index: "session_date",
                      handleChange: setInputState,
                      value: DateFormat(userData?.session_date),
                      customStyle:
                        submitClickFlag && sessionInputErrors.session_date
                          ? { marginBottom: "0px" }
                          : {},
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container direction="row">
                <Grid
                  item
                  xs={3}
                  style={{ alignItems: "center", display: "grid" }}
                >
                  <Typography variant="h2">
                    <Box>Session time</Box>
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Grid container direction="row" spacing={10}>
                    <Grid item xs={6}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <InputLabel
                            style={{
                              fontSize: "12px",
                              marginBottom: "0.25rem",
                            }}
                            htmlFor="hours-customized-select-native"
                          >
                            Start Time
                          </InputLabel>
                          <FormControl sx={{ m: 1 }} variant="standard">
                            <Select
                              id="hours-customized-select-native"
                              value={clockData.start_time_hours}
                              onChange={(event) => {
                                selectChange(
                                  event.target.value,
                                  "start_time_hours"
                                );
                                if (clockData.start_time_minutes === "") {
                                  selectChange("00", "start_time_minutes");
                                }
                              }}
                              variant="outlined"
                              className={classes.nativeSelect}
                              style={{
                                color:
                                  clockData.start_time_hours === ""
                                    ? "#999"
                                    : "#222",
                              }}
                              displayEmpty
                              error={sessionInputErrors.start_time_hours}
                            >
                              <MenuItem
                                style={{ fontSize: "14px" }}
                                disabled
                                value=""
                              >
                                Start hour
                              </MenuItem>
                              {hourArray &&
                                hourArray.map((e) => {
                                  return (
                                    <MenuItem
                                      style={{ fontSize: "14px" }}
                                      value={e}
                                    >
                                      {e}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          style={{ display: "flex", alignItems: "flex-end" }}
                        >
                          <FormControl sx={{ m: 1 }} variant="standard">
                            <Select
                              id="minutes-customized-select-native"
                              value={
                                clockData.start_time_hours !== "24"
                                  ? clockData.start_time_minutes
                                  : "00"
                              }
                              onChange={(event) =>
                                selectChange(
                                  event.target.value,
                                  "start_time_minutes"
                                )
                              }
                              style={{
                                color:
                                  clockData.start_time_minutes === ""
                                    ? "#999"
                                    : "#222",
                              }}
                              variant="outlined"
                              displayEmpty
                              className={classes.nativeSelect}
                              error={sessionInputErrors.start_time_minutes}
                            >
                              <MenuItem
                                style={{ fontSize: "14px" }}
                                disabled
                                value=""
                              >
                                Start minutes
                              </MenuItem>
                              {minuteArray &&
                                minuteArray.map((e) => {
                                  return (
                                    <MenuItem
                                      value={e}
                                      disabled={
                                        clockData.start_time_hours === "24" &&
                                        e !== "00"
                                      }
                                    >
                                      {e}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={6}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <InputLabel
                            style={{
                              fontSize: "12px",
                              marginBottom: "0.25rem",
                            }}
                            htmlFor="hours-customized-select-native"
                          >
                            End Time
                          </InputLabel>
                          <FormControl sx={{ m: 1 }} variant="standard">
                            <Select
                              id="hours-customized-select-native"
                              value={clockData.end_time_hours}
                              onChange={(event) => {
                                selectChange(
                                  event.target.value,
                                  "end_time_hours"
                                );
                                if (clockData.end_time_minutes === "") {
                                  selectChange("00", "end_time_minutes");
                                }
                              }}
                              className={classes.nativeSelect}
                              style={{
                                color:
                                  clockData.end_time_hours === ""
                                    ? "#999"
                                    : "#222",
                              }}
                              variant="outlined"
                              displayEmpty
                              error={sessionInputErrors.end_time_hours}
                            >
                              <MenuItem
                                style={{ fontSize: "14px" }}
                                disabled
                                value=""
                              >
                                End hours
                              </MenuItem>
                              {hourArray &&
                                hourArray.map((e) => {
                                  return (
                                    <MenuItem
                                      value={e}
                                      style={{ fontSize: "14px" }}
                                    >
                                      {e}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          style={{ display: "flex", alignItems: "flex-end" }}
                        >
                          <FormControl sx={{ m: 1 }} variant="standard">
                            <Select
                              id="minutes-customized-select-native"
                              value={
                                clockData.end_time_hours !== "24"
                                  ? clockData.end_time_minutes
                                  : "00"
                              }
                              onChange={(event) =>
                                selectChange(
                                  event.target.value,
                                  "end_time_minutes"
                                )
                              }
                              className={classes.nativeSelect}
                              style={{
                                color:
                                  clockData.end_time_minutes === ""
                                    ? "#999"
                                    : "#222",
                              }}
                              variant="outlined"
                              displayEmpty
                              error={sessionInputErrors.end_time_minutes}
                            >
                              <MenuItem
                                style={{ fontSize: "14px" }}
                                disabled
                                value=""
                              >
                                End minutes
                              </MenuItem>
                              {minuteArray &&
                                minuteArray.map((e) => {
                                  return (
                                    <MenuItem
                                      value={e}
                                      disabled={
                                        clockData.end_time_hours === "24" &&
                                        e !== "00"
                                      }
                                      style={{ fontSize: "14px" }}
                                    >
                                      {e}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <FormHelperText
                    style={{ margin: "2px 2px 2px 6px", color: "red" }}
                  >
                    {sessionInputErrors.start_time_hours ||
                    sessionInputErrors.start_time_minutes ||
                    sessionInputErrors.end_time_hours ||
                    sessionInputErrors.end_time_minutes
                      ? "Please enter a valid time"
                      : ""}
                  </FormHelperText>
                </Grid>
              </Grid>

              <Grid container direction="row" style={{ marginTop: 8 }}>
                <Grid
                  item
                  xs={3}
                  style={{ alignItems: "center", display: "grid" }}
                >
                  <Typography variant="h2">
                    <Box>Location</Box>
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <CustomInput
                    id="location"
                    // disabled={sessionDetail?.status === "completed" ? true : false}
                    placeholder="Location"
                    variant="outlined"
                    parentcall={setInputState}
                    value={userData.location}
                    helperText={
                      submitClickFlag && sessionInputErrors.location
                        ? "Please enter a location"
                        : ""
                    }
                    error={submitClickFlag && sessionInputErrors.location}
                  />
                </Grid>
              </Grid>
              {role === "admin" && (
                <Grid container direction="row" style={{ marginTop: 20 }}>
                  <Grid
                    item
                    xs={3}
                    style={{ alignItems: "center", display: "grid" }}
                  >
                    <Typography variant="h2">
                      <Box>Agenda</Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <FormControl style={{ width: "100%" }} variant="outlined">
                      <Typography variant="h2">
                        <TextareaAutosize
                          aria-label="minimum height"
                          name="agenda"
                          rowsMin={8}
                          className={classes.textAreaEmpty}
                          onChange={handleChangeTextArea}
                          value={textArea.agenda}
                          placeholder="Agenda"
                        />
                      </Typography>
                    </FormControl>
                    {/* <CustomInput
                    id="agenda"
                    placeholder="Agenda"
                    variant="outlined"
                    parentcall={setInputState}
                    value={userData.agenda}
                  /> */}
                  </Grid>
                </Grid>
              )}
              <Grid container direction="row" style={{ marginTop: 20 }}>
                <Grid
                  item
                  xs={3}
                  style={{ alignItems: "center", display: "grid" }}
                >
                  <Typography variant="h2">
                    <Box>Stakeholders involved</Box>
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <CustomSelectMulti
                    id="stakeholder_Attribute"
                    itemArr={stakeholderListsArr}
                    parentcall={onChangeMultiItem}
                    placeholder={"Search by Stakeholders involved"}
                    value={stakeholder_Attribute}
                    error={
                      submitClickFlag && sessionInputErrors.stakeHoldersInvolved
                    }
                    helperText={
                      submitClickFlag && sessionInputErrors.stakeHoldersInvolved
                        ? "Please select the stakeholders involved"
                        : ""
                    }
                    // className={classes.custom_timepicker}
                  />
                </Grid>
              </Grid>
              <Grid container direction="row" style={{ marginTop: 20 }}>
                <Grid
                  item
                  xs={3}
                  style={{ alignItems: "center", display: "grid" }}
                >
                  <Typography variant="h2">
                    <Box>Add session notes</Box>
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <FormControl style={{ width: "100%" }} variant="outlined">
                    <Typography variant="h2">
                      <TextareaAutosize
                        aria-label="minimum height"
                        name="session_notes"
                        rowsMin={8}
                        className={classes.textAreaEmpty}
                        onChange={handleChangeTextArea}
                        value={textArea.session_notes}
                        placeholder="Add session notes"
                      />
                    </Typography>
                    {/* {submitClickFlag && !textArea.session_notes ?
                      <FormHelperText style={{ color: 'red' }}>Please enter the
                        session notes</FormHelperText> : <></>} */}
                  </FormControl>
                  {/* <CustomInput
                    id="session_notes"
                    variant="outlined"
                    placeholder="Add session notes"
                    parentcall={setInputState}
                    value={userData.session_notes}
                  /> */}
                </Grid>
              </Grid>
              {showAcuityNotes && role === "admin" && (
                <Grid container direction="row" style={{ marginTop: 20 }}>
                  <Grid
                    item
                    xs={3}
                    style={{ alignItems: "center", display: "grid" }}
                  >
                    <Typography variant="h2">
                      <Box>Add note to Acuity Admin</Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <FormControl style={{ width: "100%" }} variant="outlined">
                      <Typography variant="h2">
                        <TextareaAutosize
                          aria-label="minimum height"
                          name="note_to_acuity_admin"
                          rowsMin={8}
                          className={classes.textAreaEmpty}
                          onChange={handleChangeTextArea}
                          value={textArea.note_to_acuity_admin}
                          placeholder="Add note to Acuity Admin"
                        />
                      </Typography>

                      {/* {submitClickFlag && !textArea.note_to_acuity_admin ?
                      <FormHelperText style={{ color: 'red' }}>Please add note to Acuity Admin</FormHelperText> : <></>} */}
                    </FormControl>
                    {/* <CustomInput
                    id="note_to_acuity_admin"
                    variant="outlined"
                    placeholder="Add note to Acuity Admin"
                    parentcall={setInputState}
                    value={userData.note_to_acuity_admin}
                  /> */}
                  </Grid>
                </Grid>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Box px={3} py={2}>
              <Button
                disableElevation
                variant="contained"
                onClick={handleClose}
                style={{ textTransform: "none" }}
              >
                Cancel
              </Button>
              <Button
                disableElevation
                type="submit"
                variant="contained"
                color="secondary"
                style={{ marginLeft: 10, textTransform: "none" }}
              >
                Save
              </Button>
            </Box>
          </DialogActions>
        </form>
      </Dialog>
      {dialogState?.isOpen && (
        <AlertDialog
          dialogState={dialogState}
          trueButtonName="Complete"
          falseButtonName="Cancel"
          dialogContent={`Have you added your session notes ? If not, please do this before closing the session.`}
          handleSubmit={(value) => {
            updateSession("session_details/complete_session");
            setSessionStatus(true);
          }}
          handleClose={() => setDialogState(undefined)}
        />
      )}
    </>
  );
}

export default Sessions;
